import { render, staticRenderFns } from "./ThumbnailGenerator.vue?vue&type=template&id=3585ae61&"
import script from "./ThumbnailGenerator.vue?vue&type=script&lang=js&"
export * from "./ThumbnailGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports